// @flow

const scrollStep = 3;
const leftScrollSide = 0.15;
const rightScrollSide = 0.85;

type GetScrollStep = ({
    width: number,
    height: number,
    top: number,
    left: number,
}, {
    x: number,
    y: number,
}) => number;

export const getScrollStep: GetScrollStep = (rect, {x}) => {
    const {left, width} = rect;
    const currentOffsetLeft = x - left;
    const leftSide = width * leftScrollSide;
    const rightSide = width * rightScrollSide;

    if (currentOffsetLeft < leftSide) {
        return -scrollStep;
    }

    if (currentOffsetLeft > rightSide) {
        return scrollStep;
    }

    return 0;
};
